import { useState, useEffect } from "react";

import { api_without_cancellation } from "../../../../api/api";

const useGetUserPermission = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const fetchUserPermissions = async () => {
    setLoading(true);
    try {
      const response = await api_without_cancellation.get(
        "/api/firmsetting-page/user-permissions/"
      );
      setData(response.data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserPermissions();
  }, []);

  return { data, loading, error, refetch: fetchUserPermissions };
};

export default useGetUserPermission;
